import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M22.57,4H11.93A1.47,1.47,0,0,0,10.5,5.5v9.78a.26.26,0,0,0,.11.21A3,3,0,0,1,12,17.77a.25.25,0,0,0,.25.23h3.52a.25.25,0,0,0,.25-.23,3,3,0,0,1,6,0,.25.25,0,0,0,.25.23H23.5a.5.5,0,0,0,.5-.5V5.5A1.47,1.47,0,0,0,22.57,4Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M0,16.5a2,2,0,0,0,2,2H5.76A.27.27,0,0,0,6,18.42.22.22,0,0,0,6,18.23,1.77,1.77,0,0,1,6,18a3,3,0,0,1,2.77-3A.25.25,0,0,0,9,14.76V7.5a1,1,0,0,0-1-1H5a5,5,0,0,0-5,5Zm5-8H6.75A.25.25,0,0,1,7,8.75v2.5a.25.25,0,0,1-.25.25H2.26a.23.23,0,0,1-.18-.08A.26.26,0,0,1,2,11.23,3,3,0,0,1,5,8.5Z",
        fill: "currentColor"
      }),
      _createElementVNode("circle", {
        cx: "9",
        cy: "18",
        r: "2",
        fill: "currentColor"
      }),
      _createElementVNode("circle", {
        cx: "19",
        cy: "18",
        r: "2",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }